/**
 * 处理用户中心返回的认证信息
 * 用户中心服务应该在认证完成后通过URL参数返回token和用户信息
 */

import store from '@/store'

/**
 * 解析URL参数中的认证信息
 * 预期格式：?token=xxx&userInfo=base64EncodedJson
 */
export function parseAuthFromUrl() {
  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('token')
  const userInfoBase64 = urlParams.get('userInfo')
  
  if (token && userInfoBase64) {
    try {
      // 解码base64编码的用户信息
      const userInfoJson = atob(userInfoBase64)
      const userInfo = JSON.parse(userInfoJson)
      
      return {
        token,
        userInfo
      }
    } catch (error) {
      console.error('解析用户中心返回的认证信息失败:', error)
      return null
    }
  }
  
  return null
}

/**
 * 处理用户中心返回的认证信息并登录
 */
export async function handleUserCenterAuth() {
  const authData = parseAuthFromUrl()
  
  if (authData) {
    try {
      // 调用store的登录action
      await store.dispatch('user/login', {
        token: authData.token,
        userInfo: authData.userInfo
      })
      
      // 清除URL中的认证参数
      const cleanUrl = window.location.origin + window.location.pathname
      window.history.replaceState({}, document.title, cleanUrl)
      
      return true
    } catch (error) {
      console.error('用户中心认证登录失败:', error)
      return false
    }
  }
  
  return false
}

/**
 * 检查并处理用户中心返回的认证信息
 * 应该在应用初始化时调用
 */
export function checkAndHandleUserCenterAuth() {
  return handleUserCenterAuth()
}
